import * as globals from "./globals";
import type { OctopusTheme } from "./OctopusTheme";
export const lightTheme: OctopusTheme = {
    "colorCalloutTextInfo": globals["colorScales"]["blue"]["600"],
    "colorCalloutTextSuccess": globals["colorScales"]["green"]["600"],
    "colorCalloutTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorCalloutTextDanger": globals["colorScales"]["red"]["600"],
    "colorCalloutTextFeature": globals["colorScales"]["purple"]["600"],
    "colorCalloutTextDefault": globals["colorScales"]["slate"]["600"],
    "colorCalloutTextBody": globals["colorScales"]["black"],
    "colorCalloutIconInfo": globals["colorScales"]["blue"]["600"],
    "colorCalloutIconSuccess": globals["colorScales"]["green"]["600"],
    "colorCalloutIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorCalloutIconDanger": globals["colorScales"]["red"]["600"],
    "colorCalloutIconFeature": globals["colorScales"]["purple"]["600"],
    "colorCalloutIconDefault": globals["colorScales"]["slate"]["600"],
    "colorCalloutBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorCalloutBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorCalloutBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorCalloutBorderDanger": globals["colorScales"]["red"]["500"],
    "colorCalloutBorderFeature": globals["colorScales"]["purple"]["500"],
    "colorCalloutBorderDefault": globals["colorScales"]["slate"]["500"],
    "colorCalloutBorderUpsell": "linear-gradient(180deg, #87BFEC 0%, #C5AEEE 100%)",
    "colorCalloutBackgroundInfoDefault": "rgb(from #87BFEC r g b / 0.24)",
    "colorCalloutBackgroundInfoHover": "rgb(from #87BFEC r g b / 0.40)",
    "colorCalloutBackgroundInfoPressed": "rgb(from #87BFEC r g b / 0.64)",
    "colorCalloutBackgroundSuccessDefault": "rgb(from #5ECD9E r g b / 0.24)",
    "colorCalloutBackgroundSuccessHover": "rgb(from #5ECD9E r g b / 0.40)",
    "colorCalloutBackgroundSuccessPressed": "rgb(from #5ECD9E r g b / 0.64)",
    "colorCalloutBackgroundAttentionDefault": "rgb(from #FFDF62 r g b / 0.24)",
    "colorCalloutBackgroundAttentionHover": "rgb(from #FFDF62 r g b / 0.40)",
    "colorCalloutBackgroundAttentionPressed": "rgb(from #FFDF62 r g b / 0.64)",
    "colorCalloutBackgroundDangerDefault": "rgb(from #FF9F9F r g b / 0.24)",
    "colorCalloutBackgroundDangerHover": "rgb(from #FF9F9F r g b / 0.40)",
    "colorCalloutBackgroundDangerPressed": "rgb(from #FF9F9F r g b / 0.64)",
    "colorCalloutBackgroundFeatureDefault": "rgb(from #C5AEEE r g b / 0.24)",
    "colorCalloutBackgroundFeatureHover": "rgb(from #C5AEEE r g b / 0.40)",
    "colorCalloutBackgroundFeaturePressed": "rgb(from #C5AEEE r g b / 0.64)",
    "colorCalloutBackgroundDefaultHover": "rgb(from #B2B9C5 r g b / 0.40)",
    "colorCalloutBackgroundDefaultPressed": "rgb(from #B2B9C5 r g b / 0.64)",
    "colorCalloutBackgroundUpsell": "linear-gradient(95deg, rgb(from #CDE4F7 r g b / 0.4) 0%, rgb(from #E7DEF8 r g b / 0.4) 100%)",
    "colorMenuListTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorMenuListTextSecondary": globals["colorScales"]["slate"]["600"],
    "colorMenuListTextHighlight": globals["colorScales"]["blue"]["500"],
    "colorMenuListBackgroundDefault": globals["colorScales"]["white"],
    "colorMenuListBackgroundHover": globals["colorScales"]["slate"]["100"],
    "colorMenuListBackgroundActive": globals["colorScales"]["slate"]["200"],
    "colorMenuListIconPrimary": globals["colorScales"]["slate"]["600"],
    "colorMenuListBorderPrimary": globals["colorScales"]["slate"]["200"],
    "colorTextFieldTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorTextFieldTextSecondary": globals["colorScales"]["slate"]["500"],
    "colorTextFieldTextSelected": globals["colorScales"]["blue"]["500"],
    "colorTextFieldTextDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldTextDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldBorderDefault": globals["colorScales"]["slate"]["300"],
    "colorTextFieldBorderHover": globals["colorScales"]["slate"]["500"],
    "colorTextFieldBorderActive": globals["colorScales"]["blue"]["500"],
    "colorTextFieldBorderDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldBorderDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldIconPrimary": globals["colorScales"]["slate"]["700"],
    "colorTextFieldIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorChipFilledTextPrimary": globals["colorScales"]["navy"]["600"],
    "colorChipFilledTextSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledTextInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledTextSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipFilledTextDanger": globals["colorScales"]["red"]["600"],
    "colorChipFilledBackgroundPrimary": globals["colorScales"]["navy"]["200"],
    "colorChipFilledBackgroundSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledBackgroundInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledBackgroundSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledBackgroundWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipFilledBackgroundDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledIconPrimary": globals["colorScales"]["navy"]["600"],
    "colorChipFilledIconSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledIconInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledIconSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipFilledIconDanger": globals["colorScales"]["red"]["600"],
    "colorChipOutlinedBorderPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedBorderSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedBorderWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedBorderDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedTextPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedTextSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedTextInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedTextSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedTextWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedTextDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedIconPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedIconSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedIconInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedIconSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedIconWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedIconDanger": globals["colorScales"]["red"]["500"],
    "colorChipBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorChipBackgroundPrimary": globals["colorScales"]["slate"]["200"],
    "colorChipBackgroundSecondary": globals["colorScales"]["slate"]["300"],
    "colorChipBackgroundSuccessful": globals["colorScales"]["green"]["500"],
    "colorChipBorderPrimary": globals["colorScales"]["slate"]["300"],
    "colorChipIconInverse": globals["colorScales"]["white"],
    "colorChipIconPrimary": globals["colorScales"]["slate"]["800"],
    "colorChipIconWarning": globals["colorScales"]["orange"]["500"],
    "colorChipTextInverse": globals["colorScales"]["white"],
    "colorChipTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorButtonBackgroundPrimaryDefault": globals["colorScales"]["green"]["500"],
    "colorButtonBackgroundPrimaryHover": globals["colorScales"]["green"]["600"],
    "colorButtonBackgroundPrimaryPressed": globals["colorScales"]["green"]["700"],
    "colorButtonBackgroundSecondaryDefault": "rgb(from #1A77CA r g b / 0.0)",
    "colorButtonBackgroundSecondaryHover": "rgb(from #1A77CA r g b / 0.08)",
    "colorButtonBackgroundSecondaryPressed": "rgb(from #1A77CA r g b / 0.24)",
    "colorButtonBackgroundTertiaryDefault": "rgb(from #1A77CA r g b / 0.06)",
    "colorButtonBackgroundTertiaryHover": "rgb(from #1A77CA r g b / 0.16)",
    "colorButtonBackgroundTertiaryPressed": "rgb(from #1A77CA r g b / 0.24)",
    "colorButtonBackgroundDestructiveDefault": globals["colorScales"]["red"]["500"],
    "colorButtonBackgroundDestructiveHover": globals["colorScales"]["red"]["600"],
    "colorButtonBackgroundDestructivePressed": globals["colorScales"]["red"]["700"],
    "colorButtonBackgroundQuietDefault": "rgb(from #1A77CA r g b / 0.0)",
    "colorButtonBackgroundQuietHover": "rgb(from #1A77CA r g b / 0.08)",
    "colorButtonBackgroundQuietPressed": "rgb(from #1A77CA r g b / 0.24)",
    "colorButtonBackgroundLoudDefault": globals["colorScales"]["blue"]["500"],
    "colorButtonBackgroundLoudHover": globals["colorScales"]["blue"]["600"],
    "colorButtonBackgroundLoudPressed": globals["colorScales"]["blue"]["700"],
    "colorButtonBackgroundNeutralDefault": globals["colorScales"]["slate"]["100"],
    "colorButtonBackgroundNeutralHover": globals["colorScales"]["slate"]["200"],
    "colorButtonBackgroundNeutralPressed": globals["colorScales"]["slate"]["300"],
    "colorButtonBackgroundDisabled": "rgb(from #DEE1E6 r g b / 0.56)",
    "colorButtonTextPrimary": globals["colorScales"]["white"],
    "colorButtonTextSecondary": globals["colorScales"]["blue"]["500"],
    "colorButtonTextTertiary": globals["colorScales"]["blue"]["500"],
    "colorButtonTextDestructive": globals["colorScales"]["white"],
    "colorButtonTextQuiet": globals["colorScales"]["blue"]["500"],
    "colorButtonTextLoud": globals["colorScales"]["white"],
    "colorButtonTextNeutral": globals["colorScales"]["slate"]["800"],
    "colorButtonTextDisabled": globals["colorScales"]["slate"]["400"],
    "colorButtonBorderSecondary": globals["colorScales"]["blue"]["400"],
    "colorButtonBorderDisabled": globals["colorScales"]["slate"]["200"],
    "colorButtonIconPrimary": globals["colorScales"]["white"],
    "colorButtonIconSecondary": globals["colorScales"]["blue"]["500"],
    "colorButtonIconTertiary": globals["colorScales"]["blue"]["500"],
    "colorButtonIconQuiet": globals["colorScales"]["blue"]["500"],
    "colorButtonIconLoud": globals["colorScales"]["white"],
    "colorButtonIconNeutral": globals["colorScales"]["slate"]["800"],
    "colorButtonIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorButtonIconDestructive": globals["colorScales"]["white"],
    "colorDialogBackgroundPrimary": globals["colorScales"]["white"],
    "colorDialogBackgroundSecondaryDefault": globals["colorScales"]["slate"]["100"],
    "colorDialogBackgroundSecondaryUpsell": "linear-gradient(95deg, rgb(from #1A77CA r g b / 0.6) 0%, rgb(from #895ED3 r g b / 0.6) 100%)",
    "colorDialogHelpPanelText": globals["colorScales"]["white"],
    "colorProgressBackgroundPrimary": globals["colorScales"]["blue"]["500"],
    "colorProgressBackgroundSecondary": globals["colorScales"]["blue"]["200"],
    "colorProgressTextInfo": globals["colorScales"]["blue"]["500"],
    "colorProgressBarForegroundLinear": globals["colorScales"]["blue"]["500"],
    "colorProgressBarForegroundCircular": globals["colorScales"]["blue"]["500"],
    "colorProgressBarBackgroundLinear": globals["colorScales"]["blue"]["200"],
    "colorPaginationBackgroundDefault": globals["colorScales"]["white"],
    "colorPaginationBackgroundHover": globals["colorScales"]["slate"]["400"],
    "colorPaginationBackgroundActive": globals["colorScales"]["blue"]["500"],
    "colorPaginationBackgroundDisabled": globals["colorScales"]["white"],
    "colorPaginationTextDefault": globals["colorScales"]["slate"]["800"],
    "colorPaginationTextHover": globals["colorScales"]["white"],
    "colorPaginationTextActive": globals["colorScales"]["white"],
    "colorPaginationTextDisabled": globals["colorScales"]["grey"]["400"],
    "colorPaginationIconDefault": globals["colorScales"]["slate"]["800"],
    "colorPaginationIconHover": globals["colorScales"]["white"],
    "colorPaginationIconActive": globals["colorScales"]["white"],
    "colorPaginationIconDisabled": globals["colorScales"]["grey"]["400"],
    "colorSwitchIconActive": globals["colorScales"]["blue"]["500"],
    "colorSwitchOverlayOn": "rgb(from #87BFEC r g b / 0.16)",
    "colorSwitchOverlayOff": "rgb(from #B2B9C5 r g b / 0.16)",
    "colorSwitchBackgroundOnDefault": globals["colorScales"]["blue"]["300"],
    "colorSwitchBackgroundOnDisabled": globals["colorScales"]["blue"]["200"],
    "colorSwitchBackgroundOffDefault": globals["colorScales"]["slate"]["300"],
    "colorSwitchBackgroundOffDisabled": globals["colorScales"]["slate"]["200"],
    "colorSwitchForegroundOnDefault": globals["colorScales"]["blue"]["500"],
    "colorSwitchForegroundOnDisabled": globals["colorScales"]["blue"]["300"],
    "colorSwitchForegroundOffDefault": globals["colorScales"]["slate"]["100"],
    "colorSwitchForegroundOffDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorTextSecondary": globals["colorScales"]["slate"]["600"],
    "colorTextTertiary": globals["colorScales"]["slate"]["500"],
    "colorTextDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextInversePrimary": globals["colorScales"]["white"],
    "colorTextInverseSecondary": globals["colorScales"]["slate"]["200"],
    "colorTextSelected": globals["colorScales"]["blue"]["500"],
    "colorTextInfo": globals["colorScales"]["blue"]["500"],
    "colorTextSuccess": globals["colorScales"]["green"]["500"],
    "colorTextWarning": globals["colorScales"]["orange"]["500"],
    "colorTextDanger": globals["colorScales"]["red"]["500"],
    "colorTextFeature": globals["colorScales"]["purple"]["500"],
    "colorTextLinkDefault": globals["colorScales"]["blue"]["500"],
    "colorTextLinkHover": globals["colorScales"]["blue"]["600"],
    "colorTextAttention": globals["colorScales"]["yellow"]["400"],
    "colorIconPrimary": globals["colorScales"]["slate"]["800"],
    "colorIconSecondary": globals["colorScales"]["slate"]["600"],
    "colorIconTertiary": globals["colorScales"]["slate"]["400"],
    "colorIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorIconInversePrimary": globals["colorScales"]["white"],
    "colorIconInverseSecondary": globals["colorScales"]["slate"]["200"],
    "colorIconSelected": globals["colorScales"]["blue"]["500"],
    "colorIconInfo": globals["colorScales"]["blue"]["400"],
    "colorIconSuccess": globals["colorScales"]["green"]["400"],
    "colorIconWarning": globals["colorScales"]["orange"]["400"],
    "colorIconAttention": globals["colorScales"]["yellow"]["400"],
    "colorIconDanger": globals["colorScales"]["red"]["500"],
    "colorIconFeature": globals["colorScales"]["purple"]["400"],
    "colorBorderPrimary": globals["colorScales"]["slate"]["200"],
    "colorBorderSecondary": globals["colorScales"]["slate"]["100"],
    "colorBorderTertiary": globals["colorScales"]["slate"]["300"],
    "colorBorderDisabled": globals["colorScales"]["slate"]["300"],
    "colorBorderSelected": globals["colorScales"]["blue"]["500"],
    "colorBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorBorderWarning": globals["colorScales"]["orange"]["500"],
    "colorBorderDanger": globals["colorScales"]["red"]["500"],
    "colorBorderFeature": globals["colorScales"]["purple"]["500"],
    "colorBorderLinkDefault": globals["colorScales"]["blue"]["500"],
    "colorBorderLinkHover": globals["colorScales"]["blue"]["600"],
    "colorBorderAttention": globals["colorScales"]["yellow"]["400"],
    "colorBorderBold": globals["colorScales"]["slate"]["500"],
    "colorBorderInversePrimary": globals["colorScales"]["slate"]["700"],
    "colorBorderInverseSecondary": globals["colorScales"]["slate"]["700"],
    "colorBorderDefault": globals["colorScales"]["slate"]["600"],
    "colorBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorBackgroundPrimaryHover": globals["colorScales"]["slate"]["100"],
    "colorBackgroundPrimaryPressed": globals["colorScales"]["slate"]["200"],
    "colorBackgroundPrimaryTransparent": "rgb(from #FFFFFF r g b / 0.72)",
    "colorBackgroundSecondaryDefault": globals["colorScales"]["slate"]["100"],
    "colorBackgroundSecondaryHover": globals["colorScales"]["white"],
    "colorBackgroundSecondaryPressed": globals["colorScales"]["slate"]["300"],
    "colorBackgroundSecondaryTransparent": "rgb(from #F5F6F8 r g b / 0.72)",
    "colorBackgroundTertiary": globals["colorScales"]["slate"]["200"],
    "colorBackgroundDisabled": globals["colorScales"]["slate"]["200"],
    "colorBackgroundInversePrimary": globals["colorScales"]["slate"]["900"],
    "colorBackgroundInverseSecondary": globals["colorScales"]["slate"]["700"],
    "colorBackgroundInverseNeutral": globals["colorScales"]["slate"]["600"],
    "colorBackgroundInverseSuccess": globals["colorScales"]["green"]["500"],
    "colorBackgroundSelected": globals["colorScales"]["blue"]["500"],
    "colorBackgroundInfo": globals["colorScales"]["blue"]["100"],
    "colorBackgroundSuccess": globals["colorScales"]["green"]["100"],
    "colorBackgroundWarning": globals["colorScales"]["orange"]["100"],
    "colorBackgroundDanger": globals["colorScales"]["red"]["100"],
    "colorBackgroundFeature": globals["colorScales"]["purple"]["100"],
    "colorBackgroundSupplementaryDefault": globals["colorScales"]["white"],
    "colorBackgroundAttention": globals["colorScales"]["yellow"]["100"],
    "colorBackgroundBold": globals["colorScales"]["white"],
    "colorBackgroundQuartaryDefault": globals["colorScales"]["white"],
    "colorBackgroundQuartaryHover": globals["colorScales"]["slate"]["100"],
    "colorBackgroundQuartaryPressed": globals["colorScales"]["slate"]["200"],
    "colorCarouselTextPrimary": globals["colorScales"]["white"],
    "colorCarouselIconDefault": globals["colorScales"]["slate"]["400"],
    "colorCarouselIconHover": globals["colorScales"]["slate"]["400"],
    "colorCarouselIconSelected": globals["colorScales"]["blue"]["400"],
    "colorCarouselBackgroundPrimary": globals["colorScales"]["slate"]["900"],
    "colorNavListTextDefault": globals["colorScales"]["slate"]["800"],
    "colorNavListTextHover": globals["colorScales"]["white"],
    "colorNavListTextActive": globals["colorScales"]["blue"]["500"],
    "colorNavListIconDefault": globals["colorScales"]["slate"]["800"],
    "colorNavListIconActive": globals["colorScales"]["blue"]["500"],
    "colorNavListBackgroundDefault": "rgb(from #1A77CA r g b / 0.0)",
    "colorNavListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorNavListBackgroundActive": globals["colorScales"]["slate"]["100"],
    "colorPopoverBackgroundPrimary": globals["colorScales"]["white"],
    "colorPopoverBackgroundSecondary": globals["colorScales"]["slate"]["100"],
    "colorCodeEditorBackground": globals["colorScales"]["slate"]["100"],
    "colorCodeEditorForeground": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorSelection": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorSelectionMatch": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorTextDefault": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorTextHighlight": globals["colorScales"]["orange"]["700"],
    "colorCodeEditorTextHintHighlight": globals["colorScales"]["green"]["500"],
    "colorCodeEditorTextGutter": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeSelectedBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeLinenumberColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeCursorBorderLeft": globals["colorScales"]["navy"]["800"],
    "colorCodeEditorCodeCursorBorderRight": globals["colorScales"]["navy"]["300"],
    "colorCodeEditorCodeActivelineBackground": "rgb(from #68778D r g b / 0.15)",
    "colorCodeEditorCodeFatCursorBackground": globals["colorScales"]["navy"]["300"],
    "colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeVariableColor": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorCodePropertyColor": globals["colorScales"]["orange"]["800"],
    "colorCodeEditorCodePunctuationUnitNegativeColor": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeStringOperatorColor": globals["colorScales"]["green"]["700"],
    "colorCodeEditorCodePositiveColor": globals["colorScales"]["green"]["800"],
    "colorCodeEditorCodeVariable2Variable3String2UrlColor": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeBracketCommentColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeErrorInvalidcharColor": globals["colorScales"]["red"]["700"],
    "colorCodeEditorCodeMatchingbracketColor": globals["colorScales"]["slate"]["900"],
    "colorCodeEditorCodeHintsBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeHint": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeHintActiveBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeSyntaxTagName": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxComment": globals["colorScales"]["slate"]["600"],
    "colorCodeEditorCodeSyntaxBracket": globals["colorScales"]["slate"]["600"],
    "colorCodeEditorCodeSyntaxClassName": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorCodeSyntaxPropertyName": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorCodeSyntaxVariableName": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxAttributeName": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxNumber": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxOperator": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxKeyword": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxTypeName": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxTypeOperator": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxString": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxMeta": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxRegexp": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxName": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxQuote": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxHeading": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxStrong": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxEmphasis": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxDeleted": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxDeletedBackground": globals["colorScales"]["red"]["100"],
    "colorCodeEditorCodeSyntaxAtom": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxBool": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxSpecialVariableName": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxUrl": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxEscape": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxLink": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxInvalid": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeIndentationMarkerColor": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeIndentationMarkerActiveColor": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorToolbarBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorToolbarButtonHover": globals["colorScales"]["slate"]["300"],
    "colorScrollbarBackground": "rgb(from #FFFFFF r g b / 0.0)",
    "colorScrollbarHandle": globals["colorScales"]["grey"]["400"],
    "colorCategorySelectListTextHover": globals["colorScales"]["white"],
    "colorCategorySelectListTextActive": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconDefault": globals["colorScales"]["slate"]["600"],
    "colorCategorySelectListIconActive": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconHover": globals["colorScales"]["white"],
    "colorCategorySelectListBackgroundDefault": globals["colorScales"]["slate"]["100"],
    "colorCategorySelectListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListBackgroundActive": "rgb(from #1A77CA r g b / 0.06)",
    "colorSpaceSwitcherBackgroundDefault": "rgb(from #E1E1E1 r g b / 0.32)",
    "colorSpaceSwitcherBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorSpaceSwitcherBackgroundPressed": globals["colorScales"]["blue"]["500"],
    "colorSpaceSwitcherTextDefault": globals["colorScales"]["slate"]["600"],
    "colorSpaceSwitcherTextHover": globals["colorScales"]["white"],
    "colorSpaceSwitcherTextPressed": globals["colorScales"]["white"],
    "colorSpaceSwitcherIconDefault": globals["colorScales"]["slate"]["600"],
    "colorSpaceSwitcherBorderPrimary": "rgb(from #000000 r g b / 0.16)",
    "colorNavTabBackgroundHover": globals["colorScales"]["white"],
    "colorNavTabBackgroundActive": "rgb(from #FFFFFF r g b / 0.00)",
    "colorNavTabTextDefault": globals["colorScales"]["blue"]["800"],
    "colorNavTabTextHover": globals["colorScales"]["blue"]["500"],
    "colorNavTabTextActive": globals["colorScales"]["blue"]["500"],
    "colorNavTabIconDefault": globals["colorScales"]["blue"]["800"],
    "colorNavTabIconHover": globals["colorScales"]["blue"]["500"],
    "colorNavTabIconActive": globals["colorScales"]["blue"]["500"],
    "colorNavTabBorderPrimary": globals["colorScales"]["blue"]["400"],
    "colorNavButtonIconDefault": globals["colorScales"]["slate"]["800"],
    "colorNavButtonIconHover": globals["colorScales"]["white"],
    "colorNavButtonIconPressed": globals["colorScales"]["white"],
    "colorNavButtonIconActive": globals["colorScales"]["white"],
    "colorNavButtonBackgroundDefault": "rgb(from #1A77CA r g b / 0.00)",
    "colorNavButtonBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorNavButtonBackgroundPressed": globals["colorScales"]["blue"]["600"],
    "colorNavButtonBackgroundActive": globals["colorScales"]["blue"]["500"],
    "colorBadgeBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorBadgeBackgroundInverseNeutral": globals["colorScales"]["slate"]["600"],
    "colorBadgeBackgroundInfo": globals["colorScales"]["blue"]["500"],
    "colorBadgeBackgroundSuccess": globals["colorScales"]["green"]["500"],
    "colorBadgeBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorBadgeBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorBadgeBackgroundFeature": globals["colorScales"]["purple"]["200"],
    "colorBadgeTextPrimary": globals["colorScales"]["white"],
    "colorBadgeTextSecondary": globals["colorScales"]["black"],
    "colorBadgeTextFeature": globals["colorScales"]["purple"]["700"],
    "colorBadgeIconPrimary": globals["colorScales"]["white"],
    "colorBadgeIconSecondary": globals["colorScales"]["black"],
    "colorBadgeIconFeature": globals["colorScales"]["purple"]["700"],
    "colorParallelChipBackground": globals["colorScales"]["blue"]["500"],
    "colorParallelChipIcon": globals["colorScales"]["white"],
    "colorProcessWrapperBackgroundPrimary": globals["colorScales"]["blue"]["100"],
    "colorProcessWrapperBackgroundSecondary": globals["colorScales"]["blue"]["200"],
    "colorProcessContainerBorderSelected": globals["colorScales"]["blue"]["400"],
    "colorProcessContainerBackgroundSelected": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorProcessStepBackgroundPrimarySelected": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundPrimaryHover": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundSecondaryHover": globals["colorScales"]["blue"]["200"],
    "colorProcessStepBackgroundSecondaryDefault": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundTertiaryHover": globals["colorScales"]["grey"]["100"],
    "colorProcessStepBackgroundErrorPrimary": globals["colorScales"]["red"]["100"],
    "colorProcessStepBackgroundErrorHover": globals["colorScales"]["red"]["200"],
    "colorProcessStepBackgroundErrorSelected": globals["colorScales"]["red"]["200"],
    "colorProcessStepBackgroundErrorSecondary": globals["colorScales"]["red"]["300"],
    "colorProcessStepBackgroundWarningDefault": globals["colorScales"]["orange"]["100"],
    "colorProcessStepBackgroundWarningHover": globals["colorScales"]["orange"]["200"],
    "colorProcessStepBackgroundWarningSelected": globals["colorScales"]["orange"]["200"],
    "colorProcessStepBackgroundWarningSecondary": globals["colorScales"]["orange"]["300"],
    "colorProcessStepBorderDefault": globals["colorScales"]["grey"]["200"],
    "colorProcessStepBorderHover": globals["colorScales"]["blue"]["300"],
    "colorProcessStepBorderSelected": globals["colorScales"]["blue"]["400"],
    "colorProcessStepBorderDisabled": globals["colorScales"]["grey"]["200"],
    "colorProcessStepBorderErrorDefault": globals["colorScales"]["red"]["300"],
    "colorProcessStepBorderErrorHover": globals["colorScales"]["red"]["400"],
    "colorProcessStepBorderErrorSelected": globals["colorScales"]["red"]["500"],
    "colorProcessStepBorderWarningDefault": globals["colorScales"]["orange"]["300"],
    "colorProcessStepBorderWarningHover": globals["colorScales"]["orange"]["400"],
    "colorProcessStepBorderWarningSelected": globals["colorScales"]["orange"]["500"],
    "colorProcessStepIconDefault": globals["colorScales"]["blue"]["500"],
    "colorProcessStepIconErrorPrimary": globals["colorScales"]["red"]["500"],
    "colorProcessStepIconErrorSecondary": globals["colorScales"]["red"]["600"],
    "colorProcessStepIconWarningPrimary": globals["colorScales"]["orange"]["400"],
    "colorProcessStepIconWarningSecondary": globals["colorScales"]["orange"]["500"],
    "colorProcessStepTextDisabled": globals["colorScales"]["grey"]["500"],
    "colorAvatarText": globals["colorScales"]["white"],
    "colorAvatarIconPrimary": globals["colorScales"]["white"],
    "colorAvatarIconSecondary": globals["colorScales"]["navy"]["800"],
    "colorAvatarBackgroundImageDefault": globals["colorScales"]["navy"]["200"],
    "colorAvatarBackgroundImageHover": globals["colorScales"]["navy"]["300"],
    "colorAvatarBackgroundUserDefault": globals["colorScales"]["blue"]["500"],
    "colorAvatarBackgroundUserHover": globals["colorScales"]["blue"]["600"],
    "colorAvatarBackgroundSpaceDefault": globals["colorScales"]["blue"]["500"],
    "colorAvatarBackgroundSpaceHover": globals["colorScales"]["blue"]["600"],
    "colorAvatarBackgroundProjectDefault": globals["colorScales"]["navy"]["500"],
    "colorAvatarBackgroundProjectHover": globals["colorScales"]["navy"]["600"],
    "colorAvatarBackgroundTenantDefault": globals["colorScales"]["white"],
    "colorAvatarBackgroundTenantHover": globals["colorScales"]["navy"]["100"],
    "colorAvatarBackgroundTemplateDefault": globals["colorScales"]["navy"]["100"],
    "colorAvatarBackgroundTemplateHover": globals["colorScales"]["navy"]["200"],
    "colorAvatarStackBackgroundHover": globals["colorScales"]["blue"]["200"],
    "colorOverlayPrimary": "rgb(from #111A23 r g b / 0.56)",
    "colorOverlaySecondary": "rgb(from #000000 r g b / 0.31)",
    "colorCardBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorCardBackgroundSecondaryDefault": "rgb(from #FFFFFF r g b / 0.1)",
    "colorCardBackgroundSecondaryHover": "rgb(from #F5F6F8 r g b / 0.64)",
    "colorLifecycleTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorLifecycleBorderDefault": globals["colorScales"]["slate"]["600"],
    "colorLifecycleIconDefault": globals["colorScales"]["white"],
    "colorLifecycleBackgroundPrimary": globals["colorScales"]["slate"]["400"],
    "colorTagBackgroundDefault": globals["colorScales"]["blue"]["100"],
    "colorTagBackgroundHover": globals["colorScales"]["blue"]["200"],
    "colorStatusBadgeTextPrimary": globals["colorScales"]["white"],
    "colorStatusBadgeTextInverse": globals["colorScales"]["slate"]["700"],
    "colorStatusBadgeIconDefault": globals["colorScales"]["white"],
    "colorStatusBadgeIconInverse": globals["colorScales"]["slate"]["700"],
    "colorStatusBadgeBackgroundHealthy": globals["colorScales"]["green"]["500"],
    "colorStatusBadgeBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorStatusBadgeBackgroundUnhealthy": globals["colorScales"]["red"]["500"],
    "colorStatusBadgeBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorTaskStatusIconDefault": globals["colorScales"]["white"],
    "colorTaskStatusIconInverse": globals["colorScales"]["slate"]["700"],
    "colorTaskStatusBackgroundSuccess": globals["colorScales"]["green"]["500"],
    "colorTaskStatusBackgroundExecuting": globals["colorScales"]["blue"]["500"],
    "colorTaskStatusBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorTaskStatusBackgroundFailure": globals["colorScales"]["red"]["500"],
    "colorTaskStatusBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorCodeReviewTextDanger": globals["colorScales"]["red"]["700"],
    "colorCodeReviewTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorCodeReviewTextSuccess": globals["colorScales"]["green"]["700"],
    "colorPortalLinkTextHover": globals["colorScales"]["blue"]["600"],
    "colorPortalChipBackground": globals["colorScales"]["grey"]["200"],
    "colorPortalPopoverBackground": globals["colorScales"]["white"],
    "shadowExtraSmall": "0 1px 8px 0 rgba(0,0,0,0.02), 0 1px 2px 0 rgba(0,0,0,0.06)",
    "shadowSmall": "0 1px 1px 0 rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.06)",
    "shadowMedium": "0 6px 12px 0 rgba(0,0,0,0.10), 0 1px 4px 0 rgba(0,0,0,0.04)",
    "shadowLarge": "0 14px 32px -4px rgba(0,0,0,0.12), 0 2px 6px 0 rgba(0,0,0,0.10)",
    "shadowLayoutPrimary": "-2px -2px 6px 0 rgba(0,0,0,0.06)",
    "shadowDrawer": "-4px 0 16px 0 rgba(0,0,0,0.08), -12px 4px 24px -4px rgba(0,0,0,0.10)",
    "shadowFocused": "0 0 0 1px rgba(26,119,202,1), 0 0 0 5px rgba(26,119,202,0.32)",
    "shadowFocusedInset": "inset 0 0 0 4px rgba(26,119,202,0.32)"
};
